<template>
	<div class="left-menu">
		<!-- 左侧菜单，最多三级菜单 -->
		<el-menu :default-active="getActiveMenu" text-color="#40B2BA" active-text-color="#FFFFFF" :unique-opened="true"
			:collapse="isCollapse" router class="el-menu-vertical-demo">
			<template v-for="m in routersList">
				<template v-if="!m.hidden && m.noDropdown">
					<template v-for="mf in m.children">
						<template v-if="!mf.hidden">
							<!-- 一般为控制台 -->
							<el-menu-item :index="mf.path" :key="mf.name"
								:class="false&&'menu-badge'">
								<i :class="mf.meta.icon"></i><span slot="title">{{mf.meta.title}}</span>
								<img v-if="false&&mf.name=='codeGuardian'" src="@/assets/img/codeGuardian/preview.png" alt="" class="preview">
							</el-menu-item>
						</template>
					</template>
				</template>
				<template v-if="!m.hidden && !m.noDropdown && m.children && m.children.length > 0">
					<!-- 一级菜单 -->
					<el-submenu :index="m.path" :key="m.name">
						<template slot="title">
							<i :class="m.meta.icon"></i><span>{{m.meta.title}}</span>
						</template>
						<template v-for="cm1 in m.children">
							<template v-if="!cm1.hidden && cm1.children && cm1.children.length > 0">
								<!-- 三级菜单 -->
								<el-submenu :index="m.path + '/' + cm1.path" :key="cm1.name">
									<template slot="title">{{cm1.meta.title}}</template>
									<template v-for="cm2 in cm1.children">
										<el-menu-item :index="m.path + '/' + cm1.path + '/' + cm2.path" :key="cm2.name">
											{{cm2.meta.title}}
										</el-menu-item>
									</template>
								</el-submenu>
							</template>
							<template v-else>
								<!-- 二级菜单 -->
								<el-menu-item :index="m.path + '/' + cm1.path" :key="cm1.name">{{cm1.meta.title}}
								</el-menu-item>
							</template>
						</template>
					</el-submenu>
				</template>
			</template>
		</el-menu>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	export default {
		name: "LeftMenu",
		computed: {
			...mapGetters(['routersList', 'isCollapse']),
			activeMenu() {
				return this.$store.getters.tabActive
			},
			getActiveMenu() {
				this.activePathArr = [];
				let tabActive = this.$store.getters.tabActive;
				let activeUrl = this.getActiveArr(this.routersList, tabActive)
				let activePath = "";
				if (activeUrl && activeUrl.length) {
					for (let i = 0; i < activeUrl.length; i++) {
						if (activeUrl[i] != "/") activePath += "/" + activeUrl[i]
					}
				}
				return activePath.substring(1);
			}
		},
		data() {
			return {
				activePathArr: [],
				finishEveryTiku: this.$store.getters.finishEveryTiku.finish
			}
		},
		methods: {
			getActiveArr(menuList, activeTab) {
				for (const menu of menuList) {
					this.activePathArr.push(menu.path)
					if (menu.name == activeTab) return this.activePathArr
					if (menu.children && menu.children.length) {
						const findChildren = this.getActiveArr(menu.children, activeTab)
						if (findChildren.length) return findChildren
					}
					this.activePathArr.pop()
				}
				return []
			}
		}
	}
</script>

<style lang="scss" scoped>
	.left-menu {

		.el-menu {
			padding-right: 0.4rem;
		}

		.el-menu-item {
			background-color: #234458;
			margin-top: 0.6rem;
			font-size: 0.64rem;
			height: 2.24rem;
			line-height: 2.24rem;
			position: relative;

			.iconfont {
				color: #40B2BA;
				font-size: 1.5rem;
				margin-right: 0.6rem;
			}

			.preview{
				position: absolute;
				top: -0.8rem;
				right: -0.4rem;
				width: 2.96rem;
				height: 2rem;
			}
		}

		.el-menu-item:first-child {
			margin-top: 0;
		}


		.el-submenu .el-menu-item {
			height: 1.68rem;
			line-height: 1.68rem;
		}

		.el-menu-item.menu-badge {
			&::before {
				content: '';
				position: absolute;
				width: 0.6rem;
				height: 0.6rem;
				border-radius: 50%;
				background-color: #FF2222;
				right: -0.24rem;
				top: -0.24rem;
			}
		}

		.el-menu {
			height: 100%;
			overflow-x: hidden;
			overflow-y: auto;
			background-color: rgba(27, 32, 38, 0.7);
			border-right: none;
		}

		.el-menu:not(.el-menu--collapse) {
			width: 9.2rem;
			min-height: 16rem;
		}

		.el-menu::-webkit-scrollbar {
			width: 0.24rem;
			height: 1px;
		}

		.el-menu::-webkit-scrollbar-thumb {
			border-radius: 0.24rem;
			background: rgba(144, 147, 153, 0.3);
		}

		.el-menu::-webkit-scrollbar-track {
			border-radius: 0;
			background: #304156;
		}

		.el-menu-item.is-active,
		.el-menu-item:focus,
		.el-menu-item:hover {
			color: #FFF !important;
			background-color: rgba(0, 255, 252, 0.79);

			.iconfont {
				color: #FFF !important;
			}
		}
	}
</style>
